module.exports = __webpack_public_path__ + "static/img/sr.788f3e2a.svg";